module.exports = __webpack_public_path__ + "img/161.608b6379.jpg";